import { render, staticRenderFns } from "./SecondsEdit.vue?vue&type=template&id=181517ed&"
import script from "./SecondsEdit.vue?vue&type=script&lang=js&"
export * from "./SecondsEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports